import GET_DIRECT_DATA_PROBLEMS from './getDirectDataProblems.gql';
import ME from './me.gql';
import SAVE_LOAN_EVENT from './saveLoanEvent.gql';

export { GET_DIRECT_DATA_PROBLEMS, SAVE_LOAN_EVENT, ME };
